<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="server"/>
          {{ $t('phoneHost') }}
        </h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <b-tabs v-model="filterFormModel.status" @input="load">
          <b-tab :title="$t('activated')"></b-tab>
          <b-tab :title="$t('deactivated')"></b-tab>
        </b-tabs>
        <div class="tile">
          <div class="form-inline">
            <b-form-input class="mr-1 mb-1" v-model="filterFormModel.keyword" v-on:keydown.enter="load"
                          :placeholder="$t('keyword')"></b-form-input>
            <button @click="load" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
            <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
          </div>
        </div>
      </div>

      <!-- c-paging -->
      <div class="col-12">
        <div class="c-sorting" v-if="['owner', 'admin', 'tech'].includes($store.state.user.role)">
          <div class="row">
            <div class="col-lg-12 c-sorting__right">
              <div class="c-sorting__btn">
                <button @click="create" class="btn btn-sm btn-success">
                  <font-awesome-icon icon="plus"/>&nbsp;{{ $t('create') }}
                </button>
              </div>
            </div>
            <!-- col -->
          </div>
          <!-- row -->
        </div>
        <!-- c-sorting -->
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">
            {{ $t('found', [itemCount]) }}
          </div>
          <div class="c-paging__right">
            <div class="c-paging__numbers">
              <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                            v-model="filterFormModel.page" :total-rows="itemCount"
                            :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
            </div>
          </div>
        </div>
      </div>
      <!-- c-paging -->

      <div class="col-12" v-if="items.length">
        <div class="c-smart-table tile">
          <div class="row c-smart-table__title">
            <div class="col-lg-3">IP</div>
            <div class="col-lg-3">{{ $t('domain') }}</div>
            <div class="col-lg-2">{{ $t('desc') }}</div>
            <div class="col-lg-2">{{ $t('status') }}</div>
            <div class="col-lg-2"></div>
          </div>
          <div class="row" v-for="item in items" :key="item._id">
            <div class="col-lg-3">
              <p>
                <b>{{ $t('ip') }}: </b><span>{{ item.ip }}</span>
              </p>
              <p v-if="item.localIp">
                <b>{{$t('localIp')}}: </b><span>{{item.localIp}}</span>
              </p>
              <p v-if="item.backupLocalIp">
                <b>{{$t('backupLocalIp')}}: </b><span>{{item.backupLocalIp}}</span>
              </p>
              <span>
                <label class="badge badge-primary">{{ $t(item.type) }} <span v-if="item.type !== 'single' && item.cluster" >: {{item.cluster.name}}</span></label>

              </span>
              <span><label class="badge badge-info">{{ item.country.name }}</label></span>
              <span v-if="item.default"><label class="badge badge-warning">{{ $t('default') }}</label></span>
            </div>
            <div class="col-lg-3">
              <b class="c-smart-table__label">{{ $t('domain') }}: </b>
              <span>{{ item.domain }}</span>
              <span v-if="!item.domain" class="text-danger">{{ $t('notUpdated') }}</span>
            </div>
            <div class="col-lg-2">
              <b class="c-smart-table__label">{{ $t('desc') }}: </b>
              <span>{{ item.desc }}</span>
            </div>
            <div class="col-lg-2">
              <div>
                <label v-if="item.active" class="badge badge-success">{{ $t('activated') }}</label>
                <label v-if="!item.active" class="badge badge-danger">{{ $t('deactivated') }}</label>
              </div>
            </div>
            <div class="col-lg-2">
              <div class="c-smart-table__content">
                <div class="c-buttons clearfix is-2">
                  <div class="c-buttons__col">
                    <number-list-modal :host="item"></number-list-modal>
                  </div>
                  <div class="c-buttons__col">
                    <button @click="update(item._id)" type="button" v-if="['owner', 'admin', 'tech'].includes($store.state.user.role)"
                            class="btn btn-sm btn-info mr-1">
                      <font-awesome-icon icon="edit"/>&nbsp;{{ $t('edit') }}
                    </button>
                    <button @click="del(item._id)" type="button" v-if="['owner', 'admin'].includes($store.state.user.role)"
                            class="btn btn-sm btn-danger mr-1">
                      <font-awesome-icon icon="trash"/>&nbsp;{{ $t('delete') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center text-danger" v-if="!items.length">
        <span v-if="filterFormModel.page === 1 && !filterFormModel.keyword">{{ $t('notFoundCreate') }}</span>
        <span v-if="filterFormModel.page > 1 || filterFormModel.keyword">{{ $t('notFoundSearch') }}</span>
      </div>

      <div class="col-12" v-if="itemCount">
        <div class="c-paging__count" v-if="itemCount">
          {{ $t('found', [itemCount]) }}
        </div>
        <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                      v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                      @input="load">
        </b-pagination>
      </div>
    </div>
    <b-modal v-model="showForm" :title="formTitle" @ok="save" no-close-on-backdrop no-enforce-focus size="lg">
      <div class="col-md">
          <div class="alert alert-warning">
            <div><b>Lưu ý khi cập nhật host</b></div>
            <div>- Khi cập nhật host sẽ chạy reload dispatcher tới <span class="text-danger">toàn bộ proxy và routing nodes</span>, nên thận trọng chọn thời điểm để cập nhật</div>
          </div>
        </div>
      <form-select :model="formModel" :label="$t('type')" attribute="type" :errors="formErrors" :options="typeOptions"></form-select>

      <country-select :label="$t('country')" :model="formModel" :errors="formErrors"></country-select>
      <form-input :label="$t('ip')" :model="formModel" attribute="ip" :errors="formErrors"></form-input>
      <form-input v-if="formModel.type === 'single'" :label="$t('localIp')" :model="formModel" attribute="localIp" :errors="formErrors"></form-input>

      <form-nodes v-if="formModel.type === 'cluster'" label="Proxy nodes" :model="formModel" attribute="proxyNodes" :errors="formErrors"></form-nodes>
      <form-nodes v-if="formModel.type === 'cluster'" label="PBX nodes" :model="formModel" attribute="pbxNodes" :errors="formErrors"></form-nodes>
      <form-nodes v-if="formModel.type === 'cluster'" label="Routing nodes" :model="formModel" attribute="routingNodes" :errors="formErrors"></form-nodes>
      <form-nodes v-if="formModel.type === 'cluster'" label="RTP Nodes" :model="formModel" attribute="rtpNodes" :errors="formErrors"></form-nodes>

      <form-input :label="$t('domain')" :model="formModel" attribute="domain" :errors="formErrors"></form-input>
      <form-input :label="$t('desc')" :model="formModel" attribute="desc" :errors="formErrors"></form-input>

      <form-input :label="$t('controlPassword')" :model="formModel" attribute="controlPassword" :errors="formErrors"></form-input>

      <form-checkbox :chk-label="$t('activated')" :model="formModel" attribute="active" :errors="formErrors"></form-checkbox>
      <form-checkbox :chk-label="$t('default')" :model="formModel" attribute="default" :errors="formErrors"></form-checkbox>

      <template v-if="formModel._id">
        <form-checkbox :chk-label="$t('updateAllGateways')" :model="formModel" attribute="allGateways" :errors="formErrors"></form-checkbox>
        <form-checkbox :chk-label="$t('updateAllNumbers')" :model="formModel" attribute="allNumbers" :errors="formErrors"></form-checkbox>
        <form-checkbox :disabled="$store.state.user.role !== 'owner'" :chk-label="$t('updateAllUsers')" :model="formModel" attribute="allUsers" :errors="formErrors"></form-checkbox>
      </template>
    </b-modal>
  </main>
</template>

<script>
import List from '../../mixins/List';
import CRUD from "../../mixins/CRUD";
import NumberListModal from "./NumberModal";
import FormNodes from "./FormNodes";
import CountrySelect from "@/components/CountrySelect";

export default {
  components: {
    CountrySelect,
    NumberListModal,
    FormNodes
  },
  mixins: [List, CRUD],
  data: function () {
    return {
      service: '/host',
      defaultFormModel: {
        active: true,
        type: null,
        proxyNodes: null,
        pbxNodes: null,
        routingNodes: null
      },
      typeOptions: [
        {value: null, text: this.$t('chooseType')},
        {value: 'single', text: this.$t('single')},
        {value: 'cluster', text: this.$t('cluster')},
      ],
    }
  },
  i18n: {
    messages: {
      en: {
        phoneHost: 'Phone hosts',
        recordingUrl: 'Recording URL',
        eslPassword: 'ESL password',
        curlPassword: 'Curl Password',
        default: 'Default',
        localIp: 'Local IP',
        backupLocalIp: 'Backup local IP',
        single: "Single",
        proxy: "Proxy",
        pbx: "PBX",
        routing: "Routing",
        cluster: "Cluster",
        dbDSN: "Database DSN",
        controlUser: "Control User",
        controlPassword: "Control Password",
        updateAllGateways: "Update all gateways",
        updateAllNumbers: "Update all numbers",
        updateAllUsers: "Update all users"
      },
      vi: {
        phoneHost: 'Danh sách tổng đài',
        recordingUrl: 'Url ghi âm',
        eslPassword: 'Mật khẩu ESL',
        curlPassword: 'Mật khẩu curl',
        default: 'Mặc định',
        localIp: 'Địa chỉ IP local',
        backupLocalIp: 'Địa chỉ IP local dự phòng',
        chooseType: "Chọn loại tổng đài",
        single: "Tổng đài độc lập",
        proxy: "Proxy",
        pbx: "PBX",
        routing: "Routing",
        cluster: "Cluster",
        dbDSN: "Database DSN",
        controlUser: "Tài khoản Control",
        controlPassword: "Mật khẩu Control",
        updateAllGateways: "Cập nhật tất cả các gateway",
        updateAllNumbers: "Cập nhật tất cả các số điện thoại",
        updateAllUsers: "Cập nhật tất cả các user"
      }
    }
  },
  methods: {}
};
</script>